//src/components/AddProduct.jsx :-
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  CircularProgress,
  Grid,
  Typography,
  Snackbar,
  Alert,
  IconButton,
} from '@mui/material';
import { Select, MenuItem } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'; // Import Close icon
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import env from "react-dotenv";

const AddProduct = ({ open, handleClose, fetchProducts }) => {
  const navigate = useNavigate();

  const initialProductState = {
    product_code: '',
    product_name: '',
    // quantity: '',
    // daily_consumption: '',
    backup_time: '',
    base_uom: '',
    cost_per_unit: '',
    item_category: '',
    location: '',
  };
  
  const [product, setProduct] = useState(initialProductState);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const validate = () => {
    const newErrors = {};
    if (!product.product_code.trim()) newErrors.product_code = 'Please enter a raw material code';
    if (!product.product_name.trim()) newErrors.product_name = 'Please enter a raw material name';
    // if (!product.quantity || isNaN(product.quantity))
      // newErrors.quantity = 'Please enter a quantity';
    // if (!product.daily_consumption || isNaN(product.daily_consumption))
    //   newErrors.daily_consumption = 'Please enter a daily consumption';
    if (!product.backup_time || isNaN(product.backup_time))
      newErrors.backup_time = 'Please enter a backup time';
    if (!product.base_uom.trim()) newErrors.base_uom = 'Please enter a base UOM';
    if (!product.cost_per_unit || isNaN(product.cost_per_unit) || product.cost_per_unit < 0)
      newErrors.cost_per_unit = 'Please enter a valid cost per unit';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setProduct({
      ...product,
      [e.target.name]: e.target.value,
    });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleSubmit = () => {
    if (!validate()) return;
  
    setLoading(true);
  
    // Check if the product_code already exists
    axios
      .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/products/exists`, {
        params: { product_code: product.product_code },
      })
      .then((response) => {
        if (response.data.exists) {
          setErrorMessage('Raw Material already exists. Please use a unique Raw Material Code.');
          setLoading(false);
        } else {
          // If the product_code doesn't exist, proceed with creating the product
          axios
            .post(`${process.env.REACT_APP_PJCBACKEND_URL}/api/products`, product)
            .then(() => {
              fetchProducts();
              handleCloseModal();
              navigate('/rawMaterialHome');
              setLoading(false);
            })
            .catch((error) => {
              console.error('Error adding raw material:', error);
              setErrorMessage('Failed to add raw material. Please try again.');
              setLoading(false);
            });
        }
      })
      .catch((error) => {
        console.error('Error checking raw material code:', error);
        setErrorMessage('Failed to validate raw material code. Please try again.');
        setLoading(false);
      });
  };  

  const handleCloseSnackbar = () => {
    setErrorMessage('');
  };

  // Function to reset form values and errors
  const resetForm = () => {
    setProduct(initialProductState);
    setErrors({});
    setErrorMessage('');
  };
  // Close modal and reset form without refreshing
  const handleCloseModal = () => {
    resetForm();
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleCloseModal} fullWidth maxWidth="sm">
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" sx={{ flex: 1, textAlign: 'center' }}>
          Add Raw Material
        </Typography>
        <IconButton onClick={handleCloseModal} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Raw Material Code"
              name="product_code"
              variant="outlined"
              fullWidth
              value={product.product_code}
              onChange={handleChange}
              error={!!errors.product_code}
              helperText={errors.product_code}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Raw Material Name"
              name="product_name"
              variant="outlined"
              fullWidth
              value={product.product_name}
              onChange={handleChange}
              error={!!errors.product_name}
              helperText={errors.product_name}
            />
          </Grid>
          <Grid item xs={12}>
             <TextField
               select
               label="Item Category"
               name="item_category"
               variant="outlined"
               fullWidth
               value={product.item_category}
               onChange={handleChange}
               // error={!!errors.item_category}
               // helperText={errors.item_category}
             >
               <MenuItem value="">No selection</MenuItem> {/* Add this line for empty selection */}
               <MenuItem value="Raw Material">Raw Material</MenuItem>
               <MenuItem value="Consumable-Maintenance">Consumable-Maintenance</MenuItem>
               <MenuItem value="Consumable-Store">Consumable-Store</MenuItem>
               <MenuItem value="Consumable-Electrical">Consumable-Electrical</MenuItem>
             </TextField>
           </Grid>
           
           <Grid item xs={12}>
             <TextField
               select
               label="Location"
               name="location"
               variant="outlined"
               fullWidth
               value={product.location}
               onChange={handleChange}
               // error={!!errors.location}
               // helperText={errors.location}
             >
               <MenuItem value="">No selection</MenuItem> {/* Add this line for empty selection */}
               <MenuItem value="Rack 1">Rack 1</MenuItem>
               <MenuItem value="Rack 2">Rack 2</MenuItem>
               <MenuItem value="Rack 3">Rack 3</MenuItem>
               <MenuItem value="Rack 4">Rack 4</MenuItem>
             </TextField>
           </Grid>

          {/* <Grid item xs={12} sm={6}>
            <TextField
              label="Quantity"
              name="quantity"
              variant="outlined"
              fullWidth
              value={product.quantity}
              onChange={handleChange}
              error={!!errors.quantity}
              helperText={errors.quantity}
            />
          </Grid> */}
          {/* <Grid item xs={12} sm={6}>
            <TextField
              label="Daily Consumption"
              name="daily_consumption"
              variant="outlined"
              fullWidth
              value={product.daily_consumption}
              onChange={handleChange}
              error={!!errors.daily_consumption}
              helperText={errors.daily_consumption}
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Cost Per Unit"
              name="cost_per_unit"
              type="number"
              variant="outlined"
              fullWidth
              value={product.cost_per_unit}
              onChange={handleChange}
              error={!!errors.cost_per_unit}
              helperText={errors.cost_per_unit}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Backup Time"
              name="backup_time"
              type="number"
              variant="outlined"
              fullWidth
              value={product.backup_time}
              onChange={handleChange}
              error={!!errors.backup_time}
              helperText={errors.backup_time}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Base UOM"
              name="base_uom"
              variant="outlined"
              fullWidth
              value={product.base_uom}
              onChange={handleChange}
              error={!!errors.base_uom}
              helperText={errors.base_uom}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={handleCloseModal} color="secondary" disabled={loading}
        sx={{ marginRight: 2,':hover': {
                      bgcolor: '#4863C0', // theme.palette.primary.main
                      color: 'white',
                    }, }}
        >
          Cancel
        </Button>
        <Button onClick={handleSubmit} disabled={loading} 
          sx={{backgroundColor:'#4863A0',':hover': {
                      bgcolor: '#4863C0', // theme.palette.primary.main
                      color: 'white',
                    },}} 
                    variant="contained"
        >
          {loading ? <CircularProgress size={24} /> : 'Save'}
        </Button>
      </DialogActions>
      <Snackbar
        open={!!errorMessage}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Top center position
      >
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

AddProduct.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  fetchProducts: PropTypes.func.isRequired,
};

export default AddProduct;
